import React from 'react';
import { useIntl } from 'react-intl';
import type { SongPublishConnection } from 'fym-shared/src/music24/songPublish';
import { TypedMemo } from '../../../common/types';
import { soundCloudUploadMessages as m } from '../soundCloudMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for SongUpload; each part uses its own slice of it */
import styles from './SongUpload.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SongUploadGoesToProps {
  connection: SongPublishConnection;
  onOpenCatalog: () => void;
}

/** "Goes to" (design c3): the SoundCloud profile of the connection, and "Change in Catalog". */
const SongUploadGoesToComponent: React.FC<SongUploadGoesToProps> = ({ connection, onOpenCatalog }) => {
  const intl = useIntl();
  return (
    <div className={styles.box}>
      <span className={styles.label}>{intl.formatMessage(m.goesTo)}</span>
      <div className={styles.goes}>
        {connection.avatarUrl !== null && <img src={connection.avatarUrl} alt="" />}
        <div className={styles.goesText}>
          <b>{connection.displayName ?? ''}</b>
          {connection.profileUrl !== null && <small>{connection.profileUrl.replace(/^https?:\/\//, '')}</small>}
        </div>
        <button type="button" className="btn btn-link btn-sm p-0" onClick={onOpenCatalog}>
          {intl.formatMessage(m.changeInCatalog)}
        </button>
      </div>
    </div>
  );
};

export const SongUploadGoesTo = TypedMemo(SongUploadGoesToComponent);
